/*globals $, Scheduler */
'use strict';

// Include base block
var Block = require('../libs/block');

// Create new block
module.exports = Block.extend({
    template: '#scheduler-calendar',

    /**
     * Basic Block-initialization
     */
    init: function (orderInfo, translations) {
        this.order = orderInfo;
        // Create and initialize scheduler
        // Fill current slots or select required slots from requested date
        this.scheduler = new Scheduler(orderInfo.required_slots, translations);
        if (orderInfo.current_slots.length > 0) {
            this.scheduler.autoSelectByDatetime(orderInfo.current_slots);
        } else {
            this.scheduler.autoSelectByDate(orderInfo.date);
        }
    }
});
